var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardMc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st0{fill:#fff}.st1{fill:#015198}.st2{fill:#f7a905}.st3{fill:#444}.st4{fill:#221f20}.st6{fill:#231f20}\n    ")), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 5c.6 0 1 .4 1 1v11.9c0 .6-.5 1.1-1.1 1.1H2.1c-.6 0-1.1-.5-1.1-1.1V6.1C1 5.5 1.5 5 2.1 5H22m0-1H2.1C.9 4 0 5 0 6.1v11.8C0 19 .9 20 2.1 20h19.8c1.2 0 2.1-1 2.1-2.1V6c0-1.1-.9-2-2-2z",
    style: {
      fill: "#d2d2d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eb621d"
    },
    d: "M9.8 8.1h4.4V16H9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path__1_",
    d: "M10.1 12c0-1.5.7-3 1.9-3.9-2.2-1.7-5.3-1.4-7 .8s-1.3 5.3.8 7c1.8 1.4 4.4 1.4 6.2 0-1.2-.9-1.9-2.4-1.9-3.9z",
    style: {
      fill: "#e41522"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1 12c0 2.8-2.2 5-5 5-1.1 0-2.2-.4-3.1-1.1 2.2-1.7 2.5-4.8.8-7-.2-.3-.5-.6-.8-.8 2.2-1.7 5.3-1.3 7 .8.7.9 1.1 2 1.1 3.1z",
    style: {
      fill: "#f59e1f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMc);
export default __webpack_public_path__ + "static/media/card-mc.e4d5eb63e43153ae3d773620ed3f3d50.svg";
export { ForwardRef as ReactComponent };